import React from 'react';
import heroImage from '../../images/kyc_vizual.jpg';
import logocropImage from '../../images/OTP_logocrop_bottom_2.png';
import { Trans, useTranslation } from "react-i18next";
import LanguageSwitcher from "./LanguageSwitcher";

const Header = () => {
    useTranslation();
    return (
      <header
        className="relative w-full bg-cover bg-center"
        style={{
            backgroundImage: `url(${heroImage})`,
            minHeight: '500px',
            height: "70vh",
            overflow: 'hidden',
            backgroundAttachment: 'fixed',
        }}
        role="banner"
      >
          <div className="relative inset-0 bg-black opacity-10"></div>

          <div
              className="relative z-10 flex flex-col justify-center h-full max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8 text-white pt-12 pb-16 sm:pt-16 sm:pb-20">
              <div className="text-left">
                <div className="flex flex-row justify-between">
                  <h1 className="font-extrabold text-2xl sm:text-3xl md:text-4xl leading-tight mb-2 font-sans">
                      <Trans
                        key="title"
                        i18nKey="common.header.title"
                        components={{ br: <br /> }}
                      />
                  </h1>
                  <div className="h-10">
                      <LanguageSwitcher />
                  </div>
                </div>
                  <p className="text-lg md:text-xl font-semibold text-left font-sans leading-snug max-w-xl">
                      <Trans
                        key="description"
                        i18nKey="common.header.description"
                        components={{ br: <br /> }}
                      />
                  </p>
              </div>
              <img src={logocropImage}
                   className="w-[513px] h-[564px] absolute top-[40%] left-[16%] transform -translate-x-full hidden md:block z-[-1]"
                   alt="..."/>
          </div>
      </header>
    );
};

export default Header;
